import { useEffect, useState } from 'react'
import { APP_TRANSLATIONS, loadInterfaceTable, type AppLocale } from './app'

/**
 * The locale to render for a wanted one: the wanted locale once its table is
 * loaded, and until then the locale last shown, so a switch never shows a frame
 * of the wrong language. Starts the load itself. A table that cannot be loaded
 * (offline) leaves the shown locale in place.
 */
export function useLoadedLocale(wanted: AppLocale): AppLocale {
  const [shown, setShown] = useState<AppLocale>(() => (APP_TRANSLATIONS[wanted] ? wanted : 'en'))
  if (APP_TRANSLATIONS[wanted] && shown !== wanted) setShown(wanted)

  useEffect(() => {
    if (APP_TRANSLATIONS[wanted]) return
    let cancelled = false
    loadInterfaceTable(wanted).then(
      () => { if (!cancelled) setShown(wanted) },
      () => { /* stay on the locale shown */ },
    )
    return () => { cancelled = true }
  }, [wanted])

  return APP_TRANSLATIONS[wanted] ? wanted : shown
}
